import { ATS_API_URL, OLD_DOCUPLOAD_API } from "../../config";
import baseDataProvider, { httpClient } from "../baseDataProvider";
import { objectToQueryString } from "../helpers/ObjectQuerystring";
import { sanitizeQueryParams } from "../helpers/sanitizeQueryParams";
import { buildFilterParamsWithScreeningSearch, normalizeScreeningSearch } from "../../utils/screeningSearch";
const API_URL = ATS_API_URL;
const OLD_DOCUPLOAD_API_URL = OLD_DOCUPLOAD_API;
const API_URL_DOC = `${API_URL}/applicant`;
const getNormalizedSearchQ = (filter) =>
  sanitizeQueryParams(normalizeScreeningSearch(filter?.q)) || "";

const getList = async (resource, params) => {
    const _start = (params.pagination.page - 1) * params.pagination.perPage;
    const _end = params.pagination.page * params.pagination.perPage;
    if (resource === "verificationmanagementstats") {
      try {
        const rangeto = new Date();
        const currentDate = new Date();
        rangeto.setDate(currentDate.getDate() - 30);

        const formatDate = (date: Date) => {
          if (isNaN(date.getTime())) {
            return " ";
          }
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
          const day = date.getDate().toString().padStart(2, '0');
          const year = date.getFullYear();

          return `${month}/${day}/${year}`;
        };
        const rangefrom = params.filter.rangefrom
          ? formatDate(new Date(params.filter.rangefrom))
          : formatDate(rangeto);
        const rangetoFormatted = params.filter.rangeto
          ? formatDate(new Date(params.filter.rangeto))
          : formatDate(currentDate);

        const rangefromFinal = rangefrom || " ";
        const rangetoFinal = rangetoFormatted || " ";

        const { json }: any = await httpClient(
          `${API_URL}/admin/getverificationreportcount?q=${params.filter.q || ""}&rangefrom=${rangefromFinal || ""}&rangeto=${rangetoFinal || ""}&subscribername=${params.filter.subscribername || ""}`,
          {
            method: "GET",

          }
        );
        return {
          ...json,
          data: json?.data?.map((item, index) => ({ id: index, ...item })),
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "plaidManagementReport") {
      try {
        const page = params?.pagination?.page || 1;
        const perPage = params?.pagination?.perPage || 100;
        const _start = (page - 1) * perPage;
        const _end = page * perPage;
        const _sort = params?.sort?.field;
        const _order = params?.sort?.order || 'ASC';

        const query = new URLSearchParams({
          _start: String(_start),
          _end: String(_end),
        });

        if (_sort) {
          query.set('_sort', _sort);
          query.set('_order', _order);
        }

        Object.entries(params?.filter || {}).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
          }
        });

        const url = `${API_URL}/plaid/management-report${query.toString() ? `?${query.toString()}` : ''}`;

        const { json }: any = await httpClient(url, { method: "GET" });

        const rawRecords: any[] = Array.isArray(json?.data) ? json.data : [];

        const data = rawRecords.map((item) => ({
          ...item,
          id: item.LocationID,
          subscriberName: item.subscriberName || '',
        }));

        const total = typeof json?.total === "number" ? json.total : rawRecords.length;

        return {
          data,
          total,
        };
      } catch (e: any) {
        throw new Error(e.message || "Unable to load plaid management report");
      }
    }
    else
      if (resource == 'predefinedMessage') {
        try {
          const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
          const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
          const SubscriberDataJson = JSON.parse(SubscriberData);
          const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
          const _start = (params.pagination.page - 1) * params.pagination.perPage;
          const _end = params.pagination.page * params.pagination.perPage;
          const { json }: any = await httpClient(
            `${API_URL}/subscriber/getpredefinedmessages?subscriberid=${subscriberId}&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}&id=${params.filter?.id || ""}`,
            {
              method: "GET",

            }
          );

          return json;
        } catch (e: any) {
          throw new Error(e.message);
        }
      } else if (resource == 'predefinedMessageAdmin') {
        try {
          const _start = (params.pagination.page - 1) * params.pagination.perPage;
          const _end = params.pagination.page * params.pagination.perPage;
          const { json }: any = await httpClient(
            `${API_URL}/admin/predefinedmessages?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}&id=${params.filter?.id || ""}`,
            {
              method: "GET",

            }
          );

          return json;
        } catch (e: any) {
          throw new Error(e.message);
        }
      }
    if (resource === "getocrqueuelist") {
      try {
        // 
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/admin/getocrqueuelist?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}`,
          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == 'getAdminPermissions') {
      try {
        const { json, headers, status }: any = await httpClient(
          API_URL + `/admin/getpermissions?rolename=` + params?.filter?.role
        );

        // return json;
        return { ...json, data: json?.data?.map((item) => ({ id: item.ID, ...item })) };
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "get-admin-role-permission") {
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/admin/getroles`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.Id,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //admin third party 
    if (resource === "get-admin-thirdParty-role-permission") {
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/admin/getthirdpartyroles`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.Id,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "landLoardInbox") {
      try {
        const q = getNormalizedSearchQ(params.filter);
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getlandlordinbox?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${q}`,
          {
            method: "GET",
          }
        );
        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    } else
      if (resource === "adminScreenManagement") {
        try {
          const rangeto = new Date();
          const currentDate = new Date();
          rangeto.setDate(currentDate.getDate() - 30);

          const formatDate = (date: Date) => {
            if (isNaN(date.getTime())) {
              return " ";
            }
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
            const day = date.getDate().toString().padStart(2, '0');
            const year = date.getFullYear();

            return `${month}/${day}/${year}`;
          };
          const rangefrom = params?.filter.rangefrom
            ? formatDate(new Date(params.filter.rangefrom))
            : formatDate(rangeto);
          const rangetoFormatted = params?.filter.rangeto
            ? formatDate(new Date(params.filter.rangeto))
            : formatDate(currentDate);

          const rangefromFinal = rangefrom || " ";
          const rangetoFinal = rangetoFormatted || " ";
          const _start = (params.pagination.page - 1) * params.pagination.perPage;
          const _end = params.pagination.page * params.pagination.perPage;
          const { json }: any = await httpClient(
            `${API_URL}/admin/getscreeningmanagementreportdv?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}
          &rangefrom=${rangefromFinal || ""}&rangeto=${rangetoFinal || ""}&screeningcompany=${params?.filter.screeningcompany || ""}`,
            {
              method: "GET",

            }
          );

          return json;
        } catch (e: any) {
          throw new Error(e.message);
        }
      }
    if (resource === "adminVerificationmgt") {
      try {
        const rangeto = new Date();
        const currentDate = new Date();
        rangeto.setDate(currentDate.getDate() - 30);

        const formatDate = (date: Date) => {
          if (isNaN(date.getTime())) {
            return " ";
          }
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
          const day = date.getDate().toString().padStart(2, '0');
          const year = date.getFullYear();

          return `${month}/${day}/${year}`;
        };
        const rangefrom = params?.filter.rangefrom
          ? formatDate(new Date(params.filter.rangefrom))
          : formatDate(rangeto);
        const rangetoFormatted = params?.filter.rangeto
          ? formatDate(new Date(params.filter.rangeto))
          : formatDate(currentDate);

        const rangefromFinal = rangefrom || " ";
        const rangetoFinal = rangetoFormatted || " ";
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;

        const { json }: any = await httpClient(
          `${API_URL}/admin/getverificationmanagementreportdv?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}
          &rangefrom=${rangefromFinal || ""}&rangeto=${rangetoFinal || ""}&subscribername=${params?.filter.subscribername || ""}`,
          {
            method: "GET",
          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource === "getSystemNotification") {
      try {
        const propertyStatusArray = params?.filter?.Active;
        let activeParam = "";
        // Check if the array contains both "Active" and "Inactive"
        if (propertyStatusArray && Array.isArray(propertyStatusArray)) {
          if (propertyStatusArray.includes(1) && propertyStatusArray.includes(0)) {
            activeParam = ""; // Set to null (by not including the parameter) if both "Active" and "Inactive" are selected
          } else if (propertyStatusArray.includes(1)) {
            activeParam = "&Active=1";
          } else if (propertyStatusArray.includes(0)) {
            activeParam = "&Active=0";
          }
        }

        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/admin/getSystemNotification?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}
          &_StartDate=${params?.filter.StartDate || ""}&_EndDate=${params?.filter.EndDate || ""}&id=${params?.filter?.id || ""}&q=${params.filter?.q || ""}` + activeParam,
          {
            method: "GET",
          }
        );

        const res = {

          data: json.data.map((item: any) => ({

            id: item.id,

            ...item,
          })),

          total: json.total,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getapplicationprofiledetails") {
      try {
        const { json, headers, status }: any = await httpClient(
          API_URL + `/subscriber/getapplicationprofiledetails?id=${params?.filter?.id || ""}`,
          {
            method: "GET",
          }
        );
        const r = json;
        const res = {
          data: { ...r?.data, id: 1 },
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    //get preauth qustion for applicant in application settings
    if (resource === "getApplicationDetailsQueAns") {
      try {
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const { json, headers, status }: any = await httpClient(
          API_URL + `/subscriber/getpreauthquestionsprofileandrolewise?profileid=${params?.filter?.profileId || ""}&subscriberid=${subscriberId}&rolename=${params?.filter?.rolename || ""}`,
          {
            method: "GET",
          }
        );
        const r = json;

        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getdocumentsectionwise") {
      try {
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;

        const { json, headers, status }: any = await httpClient(
          API_URL + `/subscriber/getdocumentsectionwise?SubscriberID=${subscriberId}&ApplicationProfileID=${params?.filter?.ApplicationProfileID || ""}`,
          {
            method: "GET",
          }
        );
        const r = json;

        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getquestionssectionwise") {
      try {
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const { json, headers, status }: any = await httpClient(

          API_URL + `/subscriber/getquestionssectionwise?ApplicationProfileID=${params?.filter?.ApplicationProfileID || ""}&SubscriberID=${subscriberId}
          &RoleName=${params?.filter?.RoleName || ""}&ProfileTab=${params?.filter?.ProfileTab || ""}`,
          {
            method: "GET",
          }
        );
        const r = json;

        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource === "adminRevenueManagement") {
      try {
        const rangeto = new Date();
        const currentDate = new Date();
        rangeto.setDate(currentDate.getDate() - 30);

        const formatDate = (date: Date) => {
          if (isNaN(date.getTime())) {
            return " ";
          }
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
          const day = date.getDate().toString().padStart(2, '0');
          const year = date.getFullYear();

          return `${month}/${day}/${year}`;
        };
        const rangefrom = params?.filter.rangefrom
          ? formatDate(new Date(params.filter.rangefrom))
          : formatDate(rangeto);
        const rangetoFormatted = params?.filter.rangeto
          ? formatDate(new Date(params.filter.rangeto))
          : formatDate(currentDate);

        const rangefromFinal = rangefrom || " ";
        const rangetoFinal = rangetoFormatted || " ";
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/admin/getrevenuemanagementreportdv?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}
          &rangefrom=${rangefromFinal || ""}&rangeto=${rangetoFinal || ""}&subscribername=${params?.filter.subscribername || ""}`,
          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getgeographicalrules") {
      try {
        // 
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/admin/getgeographicalrules?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}`,
          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getinvitationlogs") {
      try {
        // 
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getinvitationlogs?subscriberid=${subscriberId}&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}`,
          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "adminLeadManagement") {
      try {
        const rangeto = new Date();
        const currentDate = new Date();
        rangeto.setDate(currentDate.getDate() - 30);

        const formatDate = (date: Date) => {
          if (isNaN(date.getTime())) {
            return " ";
          }
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
          const day = date.getDate().toString().padStart(2, '0');
          const year = date.getFullYear();

          return `${month}/${day}/${year}`;
        };
        const rangefrom = params?.filter.rangefrom
          ? formatDate(new Date(params.filter.rangefrom))
          : formatDate(rangeto);
        const rangetoFormatted = params?.filter.rangeto
          ? formatDate(new Date(params.filter.rangeto))
          : formatDate(currentDate);

        const rangefromFinal = rangefrom || " ";
        const rangetoFinal = rangetoFormatted || " ";
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const q = getNormalizedSearchQ(params.filter);
        const { json }: any = await httpClient(
          `${API_URL}/admin/getleadmanagementreportdv?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${q}
          &rangefrom=${rangefromFinal || ""}&rangeto=${rangetoFinal || ""}&subscribername=${params?.filter.subscribername || ""}`,
          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    } else if (resource == 'GETDataFiled') {
      try {
        const { json, headers, status }: any = await httpClient(
          API_URL + `/common/getdatafields`
        );

        const data = Object.keys(json.records).map((key) => { return { id: key, label: key, value: json.records[key] } });
        const res = {
          data: data,
          total: data.length,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    else if (resource == 'gusertypelist') {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json, headers, status }: any = await httpClient(
          API_URL + `/subscriber/usertypelist?subscriberid=` + params?.filter?.subscriberid || data?.subscriberid
        );
        return { ...json, data: json?.data?.map((item, index) => ({ id: index, ...item })) };
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    } else if (resource == 'getpermissions') {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json, headers, status }: any = await httpClient(
          `${API_URL}/subscriber/getpermissions?subscriberid=${params?.filter?.subscriberid || data?.subscriberid}&rolename=${params?.filter?.role}`
        );
        return { ...json, data: json?.data?.map((item) => ({ id: item.ID, ...item })) };
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //for admin thrd party
    else if (resource == 'getthirdpartypermissions') {
      try {
        const { json, headers, status }: any = await httpClient(
          API_URL + `/admin/getthirdpartypermissions`
          // ?subscriberid=`+ params?.filter?.subscriberid + `&rolename=`+ params?.filter?.role
        );
        return { ...json, data: json?.data?.map((item) => ({ id: item.ID, ...item })) };
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource == 'GETMLDetailsList') {
      try {
        // suggestion api to change post to get list 
        // 
        const raw = JSON.stringify({
          DocumentTypeID: params.filter.DocumentTypeID
        });
        const { json, headers, status }: any = await httpClient(
          API_URL_DOC + `/document/GetMLclassDetails`,
          {
            method: "POST",
            body: raw,
          }
        );
        const res = {
          data: json.records.map((item) => ({ id: item.ID, ...item })),
          total: json.records.length,
        };
        return res;
      }
      catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource == 'gettermsandcondition') {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL + `/subscriber/gettermsandcondition${params?.filter?.SubscriberID ? `?SubscriberId=${params?.filter?.SubscriberID || data?.subscriberid}` : ''} `
        );
        const res = {
          data: json.data.map((item, index) => ({ id: index + 1, ...item })),
          total: json.data.length,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource == 'gettermsandcondition_admin') {
      try {
        const { json }: any = await httpClient(
          API_URL + `/admin/gettermsandcondition`
        );
        const res = {
          data: json.data.map((item, index) => ({ id: index + 1, ...item })),
          total: json.data.length,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "Property") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        // subscriber/get-property-details/1
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/get-property-details?subscriberID=${params?.filter?.subscriberID || data?.subscriberid
          }&_sort=${params?.sort?.field || ""}&_order=${params?.sort?.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&_search=${params?.filter?.q || ""
          }&status=${params?.filter?.propertyStatus
            ? params?.filter?.propertyStatus.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //copy url
    else if (resource === "getcopyurl") {
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/common/getcopyurl?Realestate=${params.filter.Realestate}&Urltype=${params.filter.urltype}` +
          (params?.filter?.subscriberID
            ? `&subscriberID=${params?.filter?.subscriberID}`
            : "")
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    } else if (resource === "getglobalsearch") {
      try {
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const modifyFilterValues = { ...params.filter }
        if (params?.filter?.subscriberid?.value != null && params?.filter?.subscriberid?.value != undefined) {
          modifyFilterValues.subscriberid = params?.filter?.subscriberid?.value;
        }
        const filterValue = objectToQueryString(modifyFilterValues);
        // 
        const { json }: any = await httpClient(
          `${API_URL}/admin/getglobalsearch?_sort=${params?.sort.field || ''}&_order=${params?.sort.order || ''}&_start=${_start || ''}&_end=${_end || ''}&` + filterValue,
          { method: "GET" }
        );
        const r = await json;
        const data = r.data.map(item => ({ ...item, IsRevamp: item.ApplicationType == 'Application' ? true : item.IsRevamp, isAppCreatedUsingNet: !item.IsRevamp }));
        const res = { ...r, data: data }
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "mlclassdetails") {
      try {
        const { status, headers, body, json }: any = await httpClient(
          `${API_URL_DOC}/ml/mlclassdetails?doc_typeid=${params?.filter?.doc_typeid || 3
          }&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""
          }&page=${params.pagination?.page || 1}&perPage=${params.pagination?.perPage
          }`,
          { method: "GET" }
        );
        const res = json;
        return { data: res, total: headers.get("X-Total-Count") };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource == "getclassretrainlogs") {
      try {
        const { status, headers, body, json }: any = await httpClient(
          `${API_URL_DOC}/ml/getclassretrainlogs?doc_typeid=${params?.filter?.doc_typeid || 1
          }&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""
          }&page=${params.pagination?.page || 1}&perPage=${params.pagination?.perPage
          }`,
          { method: "GET" }
        );
        const res = json;
        return { data: res, total: headers.get("X-Total-Count") };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource == "getFlaggedDocuments") {
      try {
        const { status, headers, body, json }: any = await httpClient(
          `${API_URL_DOC}/ml/getFlaggedDocuments?doc_typeid=${params?.filter?.doc_typeid || 1
          }&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""
          }&page=${params.pagination?.page || 1}&perPage=${params.pagination?.perPage
          }`,
          { method: "GET" }
        );
        const res = json;
        return { data: res, total: headers.get("X-Total-Count") };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "getFlaggedSOCRData") {
      try {
        const { status, headers, body, json }: any = await httpClient(
          `${API_URL_DOC}/ml/getFlaggedSOCRData?doc_typeid=${params?.filter?.doc_typeid || 1
          }&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""
          }&page=${params.pagination?.page || 1}&perPage=${params.pagination?.perPage
          }`,
          { method: "GET" }
        );
        const res = json;
        return { data: res, total: headers.get("X-Total-Count") };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource == "getFlagSOCRStatus") {
      try {
        const { status, headers, body, json }: any = await httpClient(
          `${API_URL_DOC}/ml/getFlagSOCRStatus?doc_typeid=${params?.filter?.doc_typeid || 1
          }&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""
          }&page=${params.pagination?.page || 1}&perPage=${params.pagination?.perPage
          }`,
          { method: "GET" }
        );
        const res = json;
        return { data: res, total: headers.get("X-Total-Count") };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource === "getloginactivitylogs") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/account/getloginactivitylogs?_sort=${params?.sort.field || ""
          }&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }&search_by=${params.filter?.q || ""}&rangefrom=${params.filter.start_date || ""
          }&rangeto=${params.filter.end_date || ""}&lastdays=${params.filter?.lastdays || ""
          }&city=${params.filter?.city || ""}&state=${params.filter?.state || ""
          }&country=${params.filter?.country || ""}&q=${params.filter?.q || ""}`,
          { method: "GET" }
        );
        const res = json;
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "loginuserlogs") {
      try {
        const userValue = localStorage.getItem("username");
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/loginuserlogs?page_size=${_end || ""}` + (params?.filter?.searchcode ? `&searchcode=${params?.filter?.searchcode}` : "") +
          (params?.filter?.range_from ? `&range_from=${params?.filter?.range_from}` : "") +
          (params?.filter?.range_to ? `&range_to=${params?.filter?.range_to}` : "") +
          (params?.sort?.field ? `&sort_column=${params?.sort?.field}` : "") +
          (params?.sort?.order ? `&sort_order=${params?.sort?.order}` : "") +
          (userValue ? `&username=${userValue}` : "")
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    //For admin
    if (resource === "admin-email-template-list") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/admin/getEmailTemplateDetails?&_start=${_start || ""}&_end=${_end || ""}` +
          (params?.sort?.field ? `&_sort=${params?.sort?.field}` : "") +
          (params?.filter?.templateApplicableFor ? `&templateApplicableFor=${params?.filter?.templateApplicableFor}` : "") +
          (params?.filter?.ID ? `&ID=${params?.filter?.ID}` : "") +
          (params?.sort?.order ? `&_order=${params?.sort?.order}` : "") +
          (params?.filter?.q_email ? `&q=${params?.filter?.q_email}` : "") +
          (params?.filter?.rangefrom ? `&rangefrom=${params?.filter?.rangefrom}` : "") +
          (params?.filter?.rangeto ? `&rangeto=${params?.filter?.rangeto}` : "") +
          (params?.filter?.active ? `&active=${params?.filter?.active}` : "")

          // }&ID=${[params?.filter?.ID] || ""}&_order=${params?.sort?.order || ""}&_start=${_start || ""}&_end=${_end || ""
          // }&q=${params?.filter?.q_email || ""}&active=${params?.filter?.active || ""
          // }&rangefrom=${params?.filter?.rangefrom || ""}&rangeto=${params?.filter?.rangeto || ""}` +

        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }

    if (resource === "getAdminResources") {
      try {
        const propertyStatusArray = params?.filter?.Active;
        let activeParam = "";

        // Check if the array contains both "Active" and "Inactive"
        if (propertyStatusArray && Array.isArray(propertyStatusArray)) {
          if (propertyStatusArray.includes(1) && propertyStatusArray.includes(0)) {
            activeParam = ""; // Set to null (by not including the parameter) if both "Active" and "Inactive" are selected
          } else if (propertyStatusArray.includes(1)) {
            activeParam = "&Active=1";
          } else if (propertyStatusArray.includes(0)) {
            activeParam = "&Active=0";
          }
        }
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;

        const { json }: any = await httpClient(
          `${API_URL}/admin/getAdminResources?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}` + (params.filter?.id ? `&id=${params.filter?.id}` : "") + (params.filter.q ? `&q=${params.filter.q}` : "") + (params.filter.Active || activeParam ? `&Active=${params.filter.Active}` : ""),

          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    //     return json;
    //   } catch (e: any) {
    //     throw new Error(e.message);
    //   }&rangefrom=${params.filter.start_date || ""}&rangeto=${params.filter.end_date || ""
    // }
    if (resource === "getleadmanagementreport") {
      try {
        const rangeto = new Date();
        const currentDate = new Date();
        rangeto.setDate(currentDate.getDate() - 30);

        const formatDate = (date: Date) => {
          if (isNaN(date.getTime())) {
            return " ";
          }
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
          const day = date.getDate().toString().padStart(2, '0');
          const year = date.getFullYear();

          return `${month}/${day}/${year}`;
        };
        const rangefrom = params?.filter.rangefrom
          ? formatDate(new Date(params.filter.rangefrom))
          : formatDate(rangeto);
        const rangetoFormatted = params?.filter.rangeto
          ? formatDate(new Date(params.filter.rangeto))
          : formatDate(currentDate);

        const rangefromFinal = rangefrom || " ";
        const rangetoFinal = rangetoFormatted || " ";
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const q = getNormalizedSearchQ(params.filter);
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getleadmanagementreport?subscriberid=${subscriberId}&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${q}
          &rangefrom=${rangefromFinal || ""}&rangeto=${rangetoFinal || ""}`,

          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource === "getdocuploadmanagementreport") {
      try {
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const rangeto = new Date();
        const currentDate = new Date();
        rangeto.setDate(currentDate.getDate() - 30);

        const formatDate = (date: Date) => {
          if (isNaN(date.getTime())) {
            return " ";
          }
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
          const day = date.getDate().toString().padStart(2, '0');
          const year = date.getFullYear();

          return `${month}/${day}/${year}`;
        };
        const rangefrom = params?.filter.rangefrom
          ? formatDate(new Date(params.filter.rangefrom))
          : formatDate(rangeto);
        const rangetoFormatted = params?.filter.rangeto
          ? formatDate(new Date(params.filter.rangeto))
          : formatDate(currentDate);

        const rangefromFinal = rangefrom || " ";
        const rangetoFinal = rangetoFormatted || " ";

        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const q = getNormalizedSearchQ(params.filter);
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getdocuploadmanagementreport?subscriberid=${subscriberId}&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${q}
          ` + (rangefromFinal ? `&rangefrom=${rangefromFinal || ""}` : "") + (rangetoFinal ? `&rangeto=${rangetoFinal || ""} ` : "") + (!!params?.filter.office ? `&office=${params?.filter.office || ""}` : "") + (!!params?.filter.property ? `&property=${params?.filter.property || ""}` : ""),
          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    // shedule report api
    if (resource === "getScheduleReport") {
      try {
        // const OfficeName = localStorage.getItem("Office")
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getsubscriberreportscheduler?subscriberid=${subscriberId}&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}` +
          (params?.filter.rangefrom ? `&rangefrom=${params?.filter.rangefrom || ""}` : "") +
          (params?.filter.rangeto ? `&rangeto=${params?.filter.rangeto || ""} ` : "") +
          (params?.filter.id ? `&ID=${params?.filter.id || ""} ` : "") +
          (params?.filter.Office?.map((item) => item?.value) ? `&OfficeIDs=${params?.filter.Office?.map((item) => item?.value) || ""}` : "") +
          (params?.filter.Agent?.value ? `&UserIDs=${params?.filter.Agent?.value || ""}` : "") +
          (params?.filter.Property?.map((item) => item?.value) ? `&PropertyIDs=${params?.filter.Property?.map((item) => item?.value) || ""}` : "") +
          (params?.filter.Floor?.map((item) => item?.value) ? `&FloorIDs=${params?.filter.Floor?.map((item) => item?.value) || ""}` : "") +
          (params?.filter.Unit?.map((item) => item?.value) ? `&UnitIDs=${params?.filter.Unit?.map((item) => item?.value) || ""}` : ""),
          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getrevenuemanagementreport") {
      try {
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const rangeto = new Date();
        const currentDate = new Date();
        rangeto.setDate(currentDate.getDate() - 30);

        const formatDate = (date: Date) => {
          if (isNaN(date.getTime())) {
            return " ";
          }
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
          const day = date.getDate().toString().padStart(2, '0');
          const year = date.getFullYear();

          return `${month}/${day}/${year}`;
        };
        const rangefrom = params?.filter.rangefrom
          ? formatDate(new Date(params.filter.rangefrom))
          : formatDate(rangeto);
        const rangetoFormatted = params?.filter.rangeto
          ? formatDate(new Date(params.filter.rangeto))
          : formatDate(currentDate);

        const rangefromFinal = rangefrom || " ";
        const rangetoFinal = rangetoFormatted || " ";
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getrevenuemanagementreport?subscriberid=${subscriberId}&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}
          ` + (rangefromFinal ? `&rangefrom=${rangefromFinal || ""}` : "") + (rangetoFinal ? `&rangeto=${rangetoFinal || ""} ` : "") + (!!params?.filter.office ? `&office=${params?.filter.office || ""}` : "") + (!!params?.filter.property ? `&property=${params?.filter.property || ""}` : ""),
          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getconfidentialitylogs") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;

        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getconfidentialitylogs?subscriberid=${subscriberId || data?.subscriberid}&_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}
          &rangefrom=${params?.filter.rangefrom || ""}&rangeto=${params?.filter.rangeto || ""}&Type=${params?.filter?.Type || ""}`,

          {
            method: "GET",

          }
        );

        return json;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
  if (resource === "getadverseletter") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const propertyStatusArray = params?.filter?.active;
        let activeParam = "";

        // Check if the array contains both "Active" and "Inactive"
        if (propertyStatusArray && Array.isArray(propertyStatusArray)) {
          if (propertyStatusArray.includes(1) && propertyStatusArray.includes(0)) {
            activeParam = ""; // Set to null (by not including the parameter) if both "Active" and "Inactive" are selected
          } else if (propertyStatusArray.includes(1)) {
            activeParam = "&active=1";
          } else if (propertyStatusArray.includes(0)) {
            activeParam = "&active=0";
          }
        }
        const page_no = (params.pagination.page - 1) * params.pagination.perPage;
        const page_size = params.pagination.page * params.pagination.perPage;
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getadverseletter?subscriberid=${subscriberId || data?.subscriberid}&sortorder=${params?.sort?.order}` +
          //  (params?.filter?.active ? `&active=${params?.filter?.active}` : "")+
          (params?.filter?.searchcode ? `&searchcode=${params?.filter?.searchcode}` : "") + activeParam +
          (params?.sort?.field ? `&sortcolumn=${params?.sort?.field}` : "") +
          // (params?.sort?.order ? `&sortorder=${params?.sort?.order}` : "")+
          (params?.filter?.id ? `&id=${params?.filter?.id}` : "") + `&page_no=${page_no || ""}` + `&page_size=${page_size || ""}`,
          // &_start=${_start || ""}&_end=${_end || ""}


        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "getarchivedcancelled") {
      try {
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getarchivedcancelled?_sort=${params?.sort.field || ""
          }&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }&q=${params.filter?.q || ""}&agent=${params.filter?.Agent || ""
          }&app_invitation_type=${params.filter?.app_invitation_type || ""
          }&property=${params.filter?.Office || params.filter.Property || ""
          }&rangefrom=${params.filter.start_date || ""}&rangeto=${params.filter.end_date || ""
          }&applicationstatus=${params.filter.ApplicationStatus
            ? params.filter.ApplicationStatus.toString()
            : ""
          }&floor=${params.filter.Floor || ""}` +
          (params.filter.subscriberid ? `&subscriberid=${subscriberId}`
            : ""),
          { method: "GET" }
        );
        const res = json;
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "deletedDocument") {
      try {
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;

        const { json }: any = await httpClient(
          `${API_URL_DOC}/document/deletedDocument/${params.filter.trn_id}?_start=${_start}&_end=${_end}`
        );
        const res = json;

        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (
      resource === "getAllBlockSections" ||
      resource === "getAllColumnSections"
    ) {
      try {
        const { json }: any = await httpClient(
          API_URL_DOC + `/ml/${resource}`,
          {
            method: "GET",
          }
        );
        const r = json;
        const res = {
          data: [...r?.records],
          total: r?.records.length,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getAllFieldsByDocumentId") {
      try {
        const { json }: any = await httpClient(
          API_URL_DOC + `/ml/getAllFieldsByDocumentId/6`,
          {
            method: "GET",
          }
        );
        const r = json;
        //
        const res = {
          data: [...r.records],
          total: r.records.length,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getAllImages") {
      const { pagination, filter } = params;
      const end = pagination.perPage * (pagination.page + 1);
      const start = pagination.perPage * pagination.page;
      try {
        const { json, headers }: any = await httpClient(
          API_URL_DOC +
          `/ml/getAllImages?_end=${end}&_order=DESC&_sort=id&_start=${start}&_id=${filter.id}`,
          {
            method: "GET",
          }
        );
        const r = json;
        const total = await headers.get("X-Total-Count");
        const res = {
          data: [...r],
          total: total,
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getsubmittedauditlog") {
      try {
        // https://uatapiml.dvapply.com/api/subscriber/getsubmittedauditlog/23820
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getsubmittedauditlog/${params.filter.applicantId
          }?_sort=${params?.sort.field || ""}&_order=${params?.sort.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""
          }`,
          { method: "GET" }
        );
        const res = await json;
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getsubscriberinbox") {

      if (params.filter.ApplicationStatus?.[0] === 'Completed-Conditionally Approved') {
        params.filter.ApplicationStatus = 'CompletedConditionallyApproved';
      }
      try {
        const q = getNormalizedSearchQ(params.filter);
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getsubscriberinbox?_sort=${params?.sort.field || ""
          }&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }&q=${q}&agent=${sanitizeQueryParams(params.filter?.Agent) || ""
          }&app_invitation_type=${sanitizeQueryParams(params.filter?.app_invitation_type) || ""
          }&property=${sanitizeQueryParams(params.filter?.Office || params.filter.Property) || ""
          }&rangefrom=${sanitizeQueryParams(params.filter.start_date) || ""}&rangeto=${sanitizeQueryParams(params.filter.end_date) || ""
          }&applicationstatus=${params.filter.ApplicationStatus
            ? sanitizeQueryParams(params.filter.ApplicationStatus.toString())
            : ""
          }&floor=${params.filter.Floor || ""}` +
          (subscriberId
            ? `&subscriberid=${subscriberId}`
            : ""),
          { method: "GET" }
        );
        const r = await json;
        const response_data = r.data.map(item => ({ ...item, IsRevamp: params?.filter?.app_invitation_type == 1 ? true : item.IsRevamp, isAppCreatedUsingNet: !item.IsRevamp }));
        const res = { ...r, data: response_data }
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource === "getAdminAllinboxType") {
      try {
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        if (params.filter?.inbox_type == 'ATS_SCREENING_QUEUE') {
          const filterParams = buildFilterParamsWithScreeningSearch({
            ...params.filter,
            'app_invitation_type': 1,
            subscriberid: params?.filter?.subscriberid?.value || ''
          });
          const filterValue = objectToQueryString(filterParams);
          const { json }: any = await httpClient(`${API_URL}/admin/getatsqueue?_sort=${params?.sort.field || ''}&_order=${params?.sort.order || ''}&_start=${_start || ''}&_end=${_end || ''}&` + filterValue, { method: 'GET' });
          // const data = json.data.map(item => ({ ...item, IsRevamp: true }));
          const data = json.data.map(item => ({ ...item, IsRevamp: true, isAppCreatedUsingNet: !item.IsRevamp }));
          const res = { ...json, data: data }
          return res;
        } else if (params.filter?.inbox_type == 'ATS_LAST_30_DAYS') {
          if (params?.filter?.lastApplicationInDays?.value == undefined) {
            delete params.filter.lastApplicationInDays
          } else {
            params.filter.lastApplicationInDays = params?.filter?.lastApplicationInDays?.value
          }
          const filterParams = buildFilterParamsWithScreeningSearch({
            ...params.filter,
            'app_invitation_type': 1,
            subscriberid: params?.filter?.subscriberid?.value || ''
          });
          const filterValue = objectToQueryString(filterParams);
          const { json }: any = await httpClient(`${API_URL}/admin/getlastthirtydaysqueue?_sort=${params?.sort.field || ''}&_order=${params?.sort.order || ''}&_start=${_start || ''}&_end=${_end || ''}&` + filterValue, { method: 'GET' });
          const data = json.data.map(item => ({ ...item, IsRevamp: true, isAppCreatedUsingNet: !item.IsRevamp }));
          return { ...json, data: data }
        } else if (params.filter?.inbox_type == 'DOCUPLOAD_LAST_30_DAYS') {
          // 
          if (params?.filter?.lastApplicationInDays?.value == undefined) {
            delete params.filter.lastApplicationInDays
          } else {
            params.filter.lastApplicationInDays = params?.filter?.lastApplicationInDays?.value
          }
          const filterParams = buildFilterParamsWithScreeningSearch({
            ...params.filter,
            'app_invitation_type': 2,
            subscriberid: params?.filter?.subscriberid?.value || ''
          });
          const filterValue = objectToQueryString(filterParams);
          const { json }: any = await httpClient(`${API_URL}/admin/getlastthirtydaysqueue?_sort=${params?.sort.field || ''}&_order=${params?.sort.order || ''}&_start=${_start || ''}&_end=${_end || ''}&` + filterValue, { method: 'GET' });
          const data = json.data.map(item => ({ ...item, IsRevamp: item.IsRevamp, isAppCreatedUsingNet: !item.IsRevamp }));
          return { ...json, data: data }
        } else {
          const filterParams = buildFilterParamsWithScreeningSearch({
            ...params.filter,
            'app_invitation_type': 1,
            subscriberid: params?.filter?.subscriberid?.value || ''
          });
          const filterValue = objectToQueryString(filterParams);
          const { json }: any = await httpClient(`${API_URL}/admin/getreviewqueue?_sort=${params?.sort.field || ''}&_order=${params?.sort.order || ''}&_start=${_start || ''}&_end=${_end || ''}&` + filterValue, { method: 'GET' });
          const res = {
            ...json,
            data: json?.data?.map((item) => ({
              ...item,
              appInDAReviewQueue: item?.ApplicationType === "Application",
              ApplicationType: "Docupload",
            })),
          };
          return res;
        }
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource === "getdashboardqueuecounts") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/admin/getdashboardqueuecounts`,
          { method: "GET" }
        );
        return {
          data: json.data.map((item) => ({ id: "dashboard-queue-counts", ...item })),
          total: json.total,
        };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getadmininbox") {
      try {
        // https://uatapimlbeta.dvapply.com/ml/mlclassdetails?_end=10&_order=ASC&_sort=ClassName&_start=0&q=d
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        // &q=${params.filter?.q || ''}&agent=${params.filter?.Agent || ''}&app_invitation_type=${params.filter?.app_invitation_type || ''}&property=${params.filter?.Office || params.filter.Property || ''}&rangefrom=${params.filter.start_date || ''}&rangeto=${params.filter.end_date || ''}&applicationstatus=${params.filter.ApplicationStatus ? params.filter.ApplicationStatus.toString() : ''}&subscriberid=${params.filter.subscriberid}&floor=${params.filter.Floor || ''}
        const { json }: any = await httpClient(
          `${API_URL}/admin/getreviewqueue?_sort=${params?.sort.field || ""
          }&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }&` + objectToQueryString(params.filter),
          { method: "GET" }
        );

        const res = {
          ...json,
          data: json?.data?.map((item) => ({
            ...item,
            appInDAReviewQueue: item?.ApplicationType === "Application",

          })),
        };
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getatsqueue") {
      try {
        const filterValue = objectToQueryString(
          buildFilterParamsWithScreeningSearch(params.filter)
        );
        const { json }: any = await httpClient(`${API_URL}/admin/getatsqueue?_sort=${params?.sort.field || ''}&_order=${params?.sort.order || ''}&_start=${_start || ''}&_end=${_end || ''}&` + filterValue, { method: 'GET' });
        const data = json.data.map(item => ({ ...item, IsRevamp: true, isAppCreatedUsingNet: !item.IsRevamp }));
        const res = { ...json, data: data }
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getlastthirtydaysqueue") {
      try {
        // https://uatapimlbeta.dvapply.com/ml/mlclassdetails?_end=10&_order=ASC&_sort=ClassName&_start=0&q=d
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        // &q=${params.filter?.q || ''}&agent=${params.filter?.Agent || ''}&app_invitation_type=${params.filter?.app_invitation_type || ''}&property=${params.filter?.Office || params.filter.Property || ''}&rangefrom=${params.filter.start_date || ''}&rangeto=${params.filter.end_date || ''}&applicationstatus=${params.filter.ApplicationStatus ? params.filter.ApplicationStatus.toString() : ''}&subscriberid=${params.filter.subscriberid}&floor=${params.filter.Floor || ''}
        const filterValue = objectToQueryString(
          buildFilterParamsWithScreeningSearch(params.filter)
        );
        const { json }: any = await httpClient(`${API_URL}/admin/getlastthirtydaysqueue?_sort=${params?.sort.field || ''}&_order=${params?.sort.order || ''}&_start=${_start || ''}&_end=${_end || ''}&` + filterValue, { method: 'GET' });
        const data = json.data.map(item => ({ ...item, IsRevamp: params?.filter?.app_invitation_type == 1 ? true : item.IsRevamp, isAppCreatedUsingNet: !item.IsRevamp }));
        const res = { ...json, data: data }
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getsubscriberusage") {
      try {
        // https://uatapimlbeta.dvapply.com/ml/mlclassdetails?_end=10&_order=ASC&_sort=ClassName&_start=0&q=d
        const _start = (params.pagination.page - 1) * params.pagination.perPage;
        const _end = params.pagination.page * params.pagination.perPage;
        const { json }: any = await httpClient(
          `${API_URL}/admin/getsubscriberusage?_sort=${params?.sort.field || ""
          }&_order=${params?.sort.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }`,
          { method: "GET" }
        );
        const res = await json;
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getpredefinemessage") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getpredefinemessage?ApplicationNumber=${params.filter.appID}`,
          { method: "GET" }
        );
        const res = await json;
        return { ...res, data: res.data[0] };
        // return {...res,data:res.data.map(item=>({...item,id:item.ID}))};
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    else if (resource === "getDocumentTypeWiseMessage") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/applicant/applicant/getDocumentTypeWiseMessage/` + params?.filter?.document_id,
          { method: "GET" }
        );
        const res = await json;
        return { ...res, data: res.records, total: res.records.length };
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "get_subscriber_inbox_details") {
      const listUrl =
        `${API_URL}/subscriber/getsubscriberinboxdetails?ApplicationNumber=${params.filter.ApplicationNumber}` +
        (params.filter.subscriberid ? `&subscriberid=${params.filter.subscriberid}` : "");

      const { json: listJson }: any = await httpClient(listUrl, { method: "GET" });
      const listRes = await listJson;
      const rows: any[] = Array.isArray(listRes?.data) ? listRes.data : [];

      // Default: do NOT enrich unless explicitly enabled via meta.enrichBankIncome === true
      const enrichBankIncome = params?.meta?.enrichBankIncome === true;

      if (!enrichBankIncome) {
        return { ...listRes, data: rows };
      }

      const trnIds = Array.from(
        new Set(rows.map((r: any) => String(r?.Trnid || "")).filter(Boolean))
      );

      let plaidBankPresenceMap: Record<string, boolean> = {};
      if (trnIds.length > 0) {
        try {
          const { json: bulkJson }: any = await httpClient(
            `${API_URL}/plaid/bankIncomeValidationCheck/bulk`,
            {
              method: "POST",
              body: JSON.stringify({ trn_ids: trnIds }),
            }
          );
          const bulkRes = await bulkJson;
          const resultsArr: any[] = Array.isArray(bulkRes?.results) ? bulkRes.results : [];
          plaidBankPresenceMap = {};
          for (const r of resultsArr) {
            const key = String(r?.trn_id || "");
            if (!key) continue;
            const banks = (r as any)?.banks;
            plaidBankPresenceMap[key] = Array.isArray(banks) && banks.length > 0;
          }
        } catch (e: any) {
          console.error(e);
          plaidBankPresenceMap = {};
        }
      }

      let argyleBankPresenceMap: Record<string, boolean> = {};
      if (trnIds.length > 0) {
        try {
          const argyleResponses = await Promise.all(
            trnIds.map(async (trnId) => {
              try {
                const { json }: any = await httpClient(
                  `${API_URL}/argyle/bankIncomeValidationCheck/${encodeURIComponent(trnId)}`,
                  { method: "GET" }
                );
                const payload = await json;
                return { trnId, payload };
              } catch (innerErr) {
                return { trnId, payload: null };
              }
            })
          );

          argyleBankPresenceMap = {};
          for (const entry of argyleResponses) {
            const key = String(entry?.trnId || "");
            if (!key) continue;
            const banks = (entry?.payload as any)?.banks;
            const hasBanks = Array.isArray(banks) && banks.length > 0;
            argyleBankPresenceMap[key] = hasBanks;
          }
        } catch (e: any) {
          console.error(e);
          argyleBankPresenceMap = {};
        }
      }

      const enriched = rows.map((item: any) => {
        const key = String(item?.Trnid || "");
        const enabled = key
          ? Boolean(plaidBankPresenceMap[key] || argyleBankPresenceMap[key])
          : false;
        return { ...item, IncomeDeposits: enabled ? "Yes" : "No" };
      });

      return { ...listRes, data: enriched };
    }
    if (resource === "getagentlist") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/common/getagentlist?subscriberid=${params.filter.SubscriberID}&url=${params.filter.url}`,
          { method: "GET" }
        );
        const res = json;
        const finalRes = {
          data: res.data.map((item) => ({ ...item, id: item.UserID })),
          total: res.total,
        };
        return finalRes;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "getapplicationprofilelist") {
      try {
        const SubscriberData: any = localStorage.getItem("RaStore.switchSubscriberName");
        const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
        const SubscriberDataJson = JSON.parse(SubscriberData);
        const subscriberId = SubscriberDataJson?.value || data?.subscriberid;
        const profileStatus = params?.filter?.status;
        let activeParam = "";

        // Check if the array contains both "Active" and "Inactive"
        if (profileStatus && Array.isArray(profileStatus)) {
          if (profileStatus.includes(1) && profileStatus.includes(0)) {
            activeParam = ""; // Set to null (by not including the parameter) if both "Active" and "Inactive" are selected
          } else if (profileStatus.includes(1)) {
            activeParam = "&status=1";
          } else if (profileStatus.includes(0)) {
            activeParam = "&status=0";
          }
        }
        const url = `${API_URL}/subscriber/getapplicationprofilelist?subscriberid=${subscriberId}&_sort=${params?.sort?.field || ""}&_order=${params?.sort?.order || ""}&_start=${_start || ""}&_end=${_end || ""}&q=${params.filter?.q || ""}${activeParam}`
        const { json }: any = await httpClient(
          url,
          { method: "GET" }
        );
        const res = json;
        return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }

    if (resource == "getfloorlist") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/common/getfloorlist?subscriberid=${params.filter.SubscriberID}&propertyid=${params.filter.PropertyID}`,
          { method: "GET" }
        );
        const res = await json;
        const finalRes = {
          data: res.data.map((item) => ({ ...item, id: item.ID })),
          total: res.total,
        };
        return finalRes;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource == "getunitlist") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/common/getunitlist?subscriberid=${params.filter.SubscriberID}&floorplanid=${params.filter.PropertyID}`,
          { method: "GET" }
        );
        const res = json;
        const finalRes = {
          data: res.data.map((item) => ({ ...item, id: item.ID })),
          total: res.total,
        };
        return finalRes;
      } catch (error) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource == "getsubscribers") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/common/getsubscribers`,
          { method: "GET" }
        );
        const res = await json;
        const finalRes = {
          data: res.data.map((item) => ({ ...item, id: item.id })),
          total: res.total,
        };
        return finalRes;
      } catch (error) {
        throw new Error("something went wrong, try again!");
      }
    }

    if (resource == "getCollectiveListOfPropertyAndOffice") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/common/getCollectiveListOfPropertyAndOffice?subscriberList=[${params?.filter}]`,
          { method: "GET" }
        );
        const res = await json;
        const finalRes = {
          data: res.data.map((item) => ({ ...item, id: item.id })),
          total: res.total,
        };
        return finalRes;
      } catch (error) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource == "getlandlorddetail") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/common/getlandlorddetail?_sort=${params?.sort.field || ""
          }&subscriberid=${params?.filter?.subscriberid}&applicationnumber=${params?.filter?.ApplicationNumber
          }`,
          { method: "GET" }
        );
        const res = await json;
        const finalRes = {
          data: res.data.map((item) => ({ ...item, id: item.id })),
          total: res.total,
        };
        return finalRes;
      } catch (error) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "viewNotes") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/viewNotes/${params?.filter?.ApplicantID}`,
          {
            method: "GET",
          }
        );
        const res = await json;
        const finalRes = {
          data: res.data.map((item) => ({ ...item, id: item.id })),
          total: res.total,
        };

        return finalRes;
        // return res;
      } catch (e: any) {
        throw new Error(e.message);
      }
    }
    if (resource === "get-floor") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/get-floor?subscriberID=${params?.filter?.subscriberID || data?.subscriberid
          }&propertyID=${params?.filter?.propertyID ? params?.filter?.propertyID : ""
          }&floorID=${params?.filter?.floorID ? params?.filter?.floorID : ""
          }&_sort=${params?.sort?.field || ""}&_order=${params?.sort?.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&_search=${params?.filter?.q_floor || ""
          }&status=${params?.filter?.floorStatus
            ? params?.filter?.floorStatus.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "get-unit") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/get-unit?subscriberID=${params?.filter?.subscriberID || data?.subscriberid
          }&propertyID=${params?.filter?.propertyID ? params?.filter?.propertyID : ""
          }&unitID=${params?.filter?.unitID ? params?.filter?.unitID : ""
          }&_sort=${params?.sort?.field || ""}&_order=${params?.sort?.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&_search=${params?.filter?.q_units || ""
          }&status=${params?.filter?.unitsStatus
            ? params?.filter?.unitsStatus.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "subscriber-list") {
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/subscriber-list?&_sort=${params?.sort?.field || ""
          }&_order=${params?.sort?.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }&_search=${params?.filter?.q || ""}&_filter=${params?.filter?.subscribersStatus
            ? params?.filter?.subscribersStatus?.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "integration-setting-rule") {
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/integration-setting-rule?subscriberID=${params?.filter?.subscriberID
          }&ThirdPartyAppID=${params?.filter?.thirdPartyAppId}&ID=${params?.filter?.id ? params?.filter?.id : ""
          }&_search=${params?.filter?.q || ""}&_sort=${params?.sort?.field || ""
          }&_order=${params?.sort?.order || ""}`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "integration-setting-rule-entrata") {
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/integration-setting-rule?subscriberID=${params?.filter?.subscriberID
          }&ThirdPartyAppID=${params?.filter?.thirdPartyAppId}&ID=${params?.filter?.id ? params?.filter?.id : ""
          }&_search=${params?.filter?.q_entrata || ""}&_sort=${params?.sort?.field || ""
          }&_order=${params?.sort?.order || ""}&_filter=${params?.filter?.entrataStatus
            ? params?.filter?.entrataStatus.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "integration-setting-rule-yardi") {
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/integration-setting-rule?subscriberID=${params?.filter?.subscriberID
          }&ThirdPartyAppID=${params?.filter?.thirdPartyAppId}&ID=${params?.filter?.id ? params?.filter?.id : ""
          }&_search=${params?.filter?.q_yardi || ""}&_sort=${params?.sort?.field || ""
          }&_order=${params?.sort?.order || ""}&_filter=${params?.filter?.yardiStatus
            ? params?.filter?.yardiStatus.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "hierarchy-levels-list") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/hierarchy-levels?subscriberID=${params?.filter?.subscriberID || data?.subscriberid
          }&id=${params?.filter?.id || ""}&_sort=${params?.sort?.field || ""
          }&_order=${params?.sort?.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }&_search=${params?.filter?.q_hierarchy || ""}&_filter=${params?.filter?.hierarchyStatus
            ? params?.filter?.hierarchyStatus?.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "email-template-list") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};

      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/getEmailTemplateDetails?subscriberid=${params?.filter?.subscriberID || data?.subscriberid
          }&_sort=${params?.sort?.field || ""
          }&ID=${[params?.filter?.ID]}&_order=${params?.sort?.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }&q=${params?.filter?.q_email || ""}&active=${params?.filter?.active || ""
          }&templateApplicableFor=${params?.filter?.templateApplicableFor || ""}&rangefrom=${params?.filter?.rangefrom || ""}
          &rangeto=${params?.filter?.rangeto || ""}`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //user setup-subsciber
    if (resource === "user-setup") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        // Extract the propertyStatus array
        const propertyStatusArray = params?.filter?.propertyStatus;
        let activeParam = "";

        // Check if the array contains both "Active" and "Inactive"
        if (propertyStatusArray
          // && Array.isArray(propertyStatusArray)
        ) {
          if (propertyStatusArray.includes("Active") && propertyStatusArray.includes("Inactive")) {
            activeParam = ""; // Set to null (by not including the parameter) if both "Active" and "Inactive" are selected
          } else if (propertyStatusArray.includes("Active")) {
            activeParam = "&Active=1";
          } else if (propertyStatusArray.includes("Inactive")) {
            activeParam = "&Active=0";
          }
        }
        const { json }: any = await httpClient(
          `${API_URL}/subscriber/getuserroles?SubscriberId=${params?.filter?.SubscriberId || data?.subscriberid}&UserType=${params?.filter?.UserType}` +
          (params?.filter?.q_email ? `&SearchCode=${params?.filter?.q_email}` : "") +
          activeParam +
          (params?.sort?.order ? `&SortOrder=${params?.sort?.order}` : "") +
          (params?.filter?.id ? `&HierarchyName=${params?.filter?.id}` : "")
          + (_end ? `&page_size=${_end}` : "") +
          (params?.sort?.field ? `&SortCol=${params?.sort?.field}` : "")
        );


        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
            officeList: item.PropertyName || item.Offices,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }

    //user setup-admin
    if (resource === "user-setup-admin") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/admin/docuverususers?sortorder=${params?.sort?.order}` +
          (params?.filter?.activecode ? `&activecode=${params?.filter?.activecode}` : "") +
          (params?.filter?.searchcode ? `&searchcode=${params?.filter?.searchcode}` : "") +
          (params?.sort?.field ? `&sortcolumn=${params?.sort?.field}` : "") +
          // (params?.sort?.order ? `&sortorder=${params?.sort?.order}` : "")+
          (params?.filter?.id ? `&userid=${params?.filter?.id}` : "")



        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //user setup-admin roles
    if (resource === "user-setup-admin-role") {
      try {
        const { json }: any = await httpClient(
          `${API_URL}/admin/docuverusroles`


        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //getRole
    if (resource === "get-role") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/usertypelist?subscriberid=${params?.filter?.subscriberid || data?.subscriberid}`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.Id,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //get role of user permission
    if (resource === "get-role-permission") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/getroles?subscriberid=${params?.filter?.subscriberid || data?.subscriberid}&defaultrole=1&showrole=1`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.Id,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //get role of third party user
    if (resource === "get-role-permission-third-party") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/getroles?subscriberid=${params?.filter?.subscriberid || data?.subscriberid}&defaultrole=0&showrole=1`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.Id,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //get association list
    if (resource === "get-association") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/getassociation?subscriberid=${params?.filter?.subscriberid || data?.subscriberid}`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //getagent
    if (resource === "get-agent") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      const roleType = "Manager";
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/getagents?subscriberid=${params?.filter?.subscriberid || data?.subscriberid}&rolename=${roleType}`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }

    //get manager
    if (resource === "get-manager") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      const roleType = "Manager";
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/getmanagers?subscriberid=${params?.filter?.subscriberid || data?.subscriberid}`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    //get proprty
    if (resource === "property-list") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/propertylist?subscriberid=${params?.filter?.subscriberid || data?.subscriberid}`
        );
        const res = {
          data: json.data.map((item: any) => ({
            id: item.ID,
            ...item,
          })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "get-office") {
      const { data } = JSON.parse(<any>localStorage.getItem("auth")) || {};
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/get-office?subscriberID=${params?.filter?.subscriberID || data?.subscriberid
          }&_sort=${params?.sort?.field || ""}&_order=${params?.sort?.order || ""
          }&_start=${_start || ""}&_end=${_end || ""}&_search=${params?.filter?.q || ""
          }&status=${params?.filter?.propertyStatus
            ? params?.filter?.propertyStatus.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "application-logs") {
      try {
        const { json }: any = await httpClient(
          API_URL +
          `/subscriber/application-logs?applicationNumber=${params?.filter?.applicationNumber
          }&applicantID=${params?.filter?.applicantID}&_sort=${params?.sort?.field || ""
          }&_order=${params?.sort?.order || ""}&_start=${_start || ""}&_end=${_end || ""
          }&_search=${params?.filter?.q_Logs || ""}&_filter=${params?.filter?.subscribersStatus
            ? params?.filter?.subscribersStatus?.toString()
            : ""
          }`
        );
        const res = {
          data: json.data,
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    if (resource === "pms-logs") {
      try {
        const { json }: any = await httpClient(API_URL + `/subscriber/get-third-party-logs?ApplicationNumber=${params?.filter?.applicationNumber}&applicantID=${params?.filter?.applicantID}&_sort=${params?.sort?.field || ''}&_order=${params?.sort?.order || ''}&_start=${_start || ''}&_end=${_end || ''}&_search=${params?.filter?.q_Logs || ''}&_filter=${params?.filter?.subscribersStatus ? params?.filter?.subscribersStatus?.toString() : ''}`);
        const res = {
          data: json.data.map((item, index) => ({ ...item, id: index })),
          total: json.total,
        };
        return res;
      } catch (e) {
        throw new Error("something went wrong, try again!");
      }
    }
    return baseDataProvider.getList(resource, params);
  };


export default getList
